import { SET_PENDING_PROPOSAL_MENU_ITEM } from '@/store/modules/mainModule/types';

export default {
  [SET_PENDING_PROPOSAL_MENU_ITEM]: (state, payload) => {
    const { hasPendingProposals, showProposalsMenuItem } = payload;
    state.hasPendingProposals = hasPendingProposals;
    state.showProposalsMenuItem = showProposalsMenuItem;
  },
};
